var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn toggle-sidebar-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendToggleSidebarEvent()}}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }